import React, { useState } from 'react';
import Chat from '../../components/Chat';
import ParameterControls from '../../components/ParameterControls';

const Home: React.FC = () => {
    const [temperature, setTemperature] = useState(0.7);
    const [maxTokens, setMaxTokens] = useState(100);

    return (


        <div className="container">
            <div className="left-panel">
                <Chat temperature={temperature} maxTokens={maxTokens} />
            </div>
            <div className="right-panel">
                <ParameterControls
                    temperature={temperature}
                    maxTokens={maxTokens}
                    onTemperatureChanged={setTemperature}
                    onMaxTokensChanged={setMaxTokens}
                />
            </div>
        </div>
    );
};

export default Home;